import { spline } from '../../lib/spline';
import { m } from '../../paraglide/messages';

export interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  pad?: number;
  /** stroke color; defaults to the spark token */
  color?: string;
  /** draw a dot at the last point */
  dot?: boolean;
  className?: string;
  'aria-label'?: string;
}

/** Tiny smoothed line chart. */
export const Sparkline = ({
  values,
  width = 92,
  height = 26,
  pad = 3,
  color = 'var(--spark)',
  dot = false,
  className,
  'aria-label': ariaLabel = m.measure_sparkline_label(),
}: SparklineProps) => {
  const { line, last } = spline(values, width, height, pad);
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      role="img"
      aria-label={ariaLabel}
      className={className}
    >
      <path d={line} stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      {dot ? <circle cx={last[0].toFixed(1)} cy={last[1].toFixed(1)} r="2" fill={color} /> : null}
    </svg>
  );
};
